import {
  Button,
  LoadIndicator,
  TextBox
} from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';
import React, { useState } from 'react';
import styles from './searchBar.module.scss';
import SearchBarFilter from './SearchBarFilter/SearchBarFilter';

/* Пример конфига filterConfig
[
    {
      text: 'Номер акта',
      name: 'act',
      type: 'text'
    },
    {
      text: 'Вес',
      name: 'weight',
      type: 'number'
    },
    {
      text: 'Тип',
      name: 'type',
      type: 'select',
      options: ['первый', 'второй']
    }
  ]
*/

const SearchBar = ({
  placeholder,
  inputValue, // значение строки поиска
  setInputValue,
  dataGridInstance,
  filterData = {}, // выбранные фильтры для отправки на бэк
  setFilterData,
  contextSearch, // если указать dataGridInstance, то будет искать внутри таблицы
  filterConfig,
  onResetFilter = () => {},
  onSaveFilter = () => {},
  onCancel = () => {},
  onClickSearch = () => {},
  buttonSearchVisible, // видимость кнопки поиск
  noPadding = false
}) => {
  const [isFilterPopupVisible, setIsFilterPopupVisible] = useState(false);

  // Методы работы с модальным окном фильтрации
  const onClickFilter = () => {
    setIsFilterPopupVisible(true);
  };

  const onModalHiding = () => {
    setIsFilterPopupVisible(false);
  };

  const onModalReset = () => {
    onResetFilter();
    setFilterData({});
    setIsFilterPopupVisible(false);
  };

  const onModalSave = () => {
    onSaveFilter();
    setIsFilterPopupVisible(false);
  };

  const isFieldsTouched = Object.keys(filterData).length === 0;

  const searchFieldButtons = [
    {
      location: 'after',
      name: 'close',
      options: {
        icon: 'close',
        type: 'danger',
        stylingMode: 'text',
        visible: !!inputValue,
        onClick: () => {
          setInputValue('');
          onCancel();
          if (dataGridInstance) {
            dataGridInstance.instance.searchByText('');
          }
        },
        elementAttr: {
          class: styles.closeButton
        }
      }
    },
    {
      location: 'after',
      name: 'search',
      options: {
        text: formatMessage('searchBar').searchButton,
        stylingMode: 'filled',
        visible: buttonSearchVisible,
        icon: 'search',
        type: 'default',
        onClick: () => {
          onClickSearch();
          if (contextSearch && dataGridInstance) {
            dataGridInstance.instance.searchByText(inputValue);
          }
        },
        elementAttr: {
          class: styles.searchButton
        }
      }
    }
  ];

  const isFilterLoading = !!filterConfig && !filterConfig.length;

  return (
    <div className={(noPadding) ? styles.searchBarPadding : styles.searchBar}>
      <Button
        visible={!!filterConfig}
        onClick={onClickFilter}
        icon="filter"
        text={formatMessage('searchBar').filter}
        elementAttr={{
          class: styles.filterButton
        }}
        disabled={isFilterLoading}
        type={isFieldsTouched ? 'normal' : 'default'}
      >
        <LoadIndicator width={25} height={25} visible={isFilterLoading} />
        <span className={isFilterLoading ? styles.hide : ''}>
          <i className="dx-icon dx-icon-filter" />
          <span className={styles.buttonText}>{formatMessage('searchBar').filter}</span>
        </span>
      </Button>
      <TextBox
        placeholder={placeholder || formatMessage('searchBar').placeholder}
        stylingMode="outlined"
        className={styles.searchInput}
        value={inputValue || null}
        onValueChanged={(e) => {
          setInputValue(e.value);
        }}
        valueChangeEvent="keyup"
        buttons={searchFieldButtons}
      />
      <SearchBarFilter
        filterData={filterData}
        setFilterData={setFilterData}
        filterConfig={filterConfig}
        isFilterPopupVisible={isFilterPopupVisible}
        onModalHiding={onModalHiding}
        onModalReset={onModalReset}
        onModalSave={onModalSave}
      />
    </div>
  );
};

export default React.memo(SearchBar);
